import { render, staticRenderFns } from "./ReportFilteringSelectionCard.vue?vue&type=template&id=35482b6b&scoped=true"
import script from "./ReportFilteringSelectionCard.vue?vue&type=script&lang=ts"
export * from "./ReportFilteringSelectionCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportFilteringSelectionCard.vue?vue&type=style&index=0&id=35482b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35482b6b",
  null
  
)

export default component.exports